<template>
  <div>
    <h1 class="page-header">{{ $t('level.grade') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              >
                <p class="ts-text-gray-500">
                  <b
                    ><i
                      ><span class="text-danger">* </span>{{ $t('level.note') }}
                    </i></b
                  >
                  {{ $t('level.onlyuseratheadofficecanmodifyordelete') }}
                </p>
              </div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px;"
                  class="kh-font"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td class="kh-font">{{ record.level_name_native }}</td>
              <td>{{ record.level_name_foreign }}</td>
              <td>{{ record.level_abbr }}</td>
              <td>
                {{
                  record.sub_program !== null
                    ? record.sub_program.acps_name_foreign
                    : ''
                }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  title="edit"
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  title="delete"
                  class="text-danger"
                  @click.prevent="destroy(record.level_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'level',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      columns: [
        { name: this.$t('level.nameKh') },
        { name: this.$t('level.nameEn') },
        { name: this.$t('level.abbreviation') },
        { name: this.$t('level.subProgram') },
        {
          name: this.$t('actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('level', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.level.search
      },
      set(newVal) {
        this.$store.commit('level/SET_SEARCH', newVal)
        this.$store.commit('level/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('level/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/levels/${data.level_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('level/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'level-create') {
      this.$store.commit('level/RESET_STATE')
      this.$store.commit('level/SET_SUB_PROGRAMS', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
